import axios from "axios";
import { useFormik } from "formik";
import React, { useState } from "react";
import * as Yup from "yup";
import { API_URL } from "../../../Services/ApiService";
import { showSuccessAlert, toastEmmit } from "../../../Helper/Toastr";
import { useNavigate, useParams} from "react-router-dom";
import { useEffect } from "react";

export default function ResetPassword() {
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const [loader, setloader] = useState(false);
  const [Token, setToken] = useState("");

  const navigate = useNavigate();
  const params = useParams()

  useEffect(() => {
    console.log(params.token)
    setToken(params.token)
  }, [params])
  

  const formik = useFormik({
    initialValues: {
      password: "",
      confirm_password: "", 
    },
    validationSchema: Yup.object().shape({
      password: Yup.string().required("Password is required"),
      confirm_password: Yup.string()
        .required("Confirm Password is required")
        .oneOf([Yup.ref("password"), null], "Passwords must match"),
    }),
    onSubmit: (values) => {
      console.log(values);
      setloader(true); 
      const payload = {
        ...values,
        token: params.token,  
      };
      axios.post(API_URL.Reset_Password, payload).then(
        (res) => {
          console.log(res);
          setloader(false);
          if (res?.data?.status === true) {
            formik.resetForm();
            showSuccessAlert(res?.data?.message, navigatetoHome);
          }
        },
        (err) => {
          console.log(err?.response?.data?.message);
          toastEmmit("error", err?.response?.data?.message); 
          setloader(false);
        }
      );
    },
  });

  function navigatetoHome() {
    navigate("/home");
  }

  return (
    <>
      <div
        className=""
        style={{ height: "100vh", backgroundColor: "aliceblue" }}
      >
        <div className="align-items-center container d-flex h-100 justify-content-around index flex-wrap">
          <div className="">
            <img src="assets/img/logo/logo.png" alt="" />
          </div>
          <div className="border-0 card py-3 row shadow" style={{ width: 500 }}>
            <div className="login__heading px-5">
              <h5 className="login__title">Reset Password</h5>
              <div className="panel panel-default ">
                <div className="panel-body">
                  <form
                    className="form-horizontal"
                    onSubmit={formik.handleSubmit}
                  >
                    <div className="form-group">
                      <div className="col-md-12 my-4">
                        <div className="col-12">
                          <div
                            className="tp-register__input-box"
                            style={{ marginBottom: 10 }}
                          >
                            <label htmlFor="password1">
                              Password<sup className="error">*</sup>
                            </label>
                            <input
                              type={showPassword ? "text" : "password"}
                              id="password1"
                              name="password"
                              placeholder="Enter Password"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.password}
                            />
                            <i
                              className={
                                showPassword
                                  ? "fa-regular fa-eye"
                                  : "fa-regular fa-eye-slash"
                              }
                              onClick={() => setShowPassword(!showPassword)}
                              style={{ cursor: "pointer" }}
                            />
                            {formik.touched.password &&
                            formik.errors.password ? (
                              <div className="error mt-1">
                                {formik.errors.password}
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </div>

                      <div className="col-12">
                        <div
                          className="tp-register__input-box"
                          style={{ marginBottom: 10 }}
                        >
                          <label htmlFor="Cpassword">
                            Confirm Password<sup className="error">*</sup>
                          </label>
                          <input
                            type={showPassword1 ? "text" : "password"}
                            id="Cpassword"
                            name="confirm_password"
                            placeholder="Enter Confirm Password"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.confirm_password}
                          />
                          <i
                            className={
                              showPassword1
                                ? "fa-regular fa-eye"
                                : "fa-regular fa-eye-slash"
                            }
                            onClick={() => setShowPassword1(!showPassword1)}
                            style={{ cursor: "pointer" }}
                          />
                          {formik.touched.confirm_password &&
                          formik.errors.confirm_password ? (
                            <div className="error mt-1">
                              {formik.errors.confirm_password}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>

                    <div className="col-12 mt-4">
                      <button
                        className={`tp-btn-lg  large head tp-contact-4__btn tp-btn-square w-100 forgot ${
                          loader ? "disabled" : ""
                        }`}
                        type="submit"
                      >
                        {loader && (
                          <span>
                            <i className="fa fa-spinner fa-spin fa-fw"></i>
                          </span>
                        )}{" "}
                        {loader ? "" : "Submit"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <p />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
